var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChildBlueEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 161,
    viewBox: "0 0 140 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.934 118.708C177.194 55.7814 104.035 15.6978 81.8185 5.19189C59.6024 -5.31399 43.1983 -0.402933 20.6154 27.7778C-1.96751 55.9585 1.20841 104.636 0.879989 125.155C0.551575 145.673 39.3595 197.367 115.934 118.708Z",
    fill: "#0056CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildBlueEdge);
export default __webpack_public_path__ + "static/media/child-blue-edge.3f44d0cd.svg";
export { ForwardRef as ReactComponent };